<template>
  <p v-if="message">
    {{ message }}
  </p>
</template>

<script>
export default {
  props: {
    message: String,
  },
};
</script>

<style scoped>
p {
  background: #ffcc6a;
  color: #0e3f70;
  border-radius: 6px;
  min-height: 24px;
  padding: 12px;
  text-align: center;
}
</style>